import React from "react";

export default function Marquee({ items = [], className = "" }) {
  const content = items.length ? items : ["Technology", "Finance", "Music", "Words", "Sustainability", "Sahyadris"];
  const row = [...content, ...content];
  return (
    <div className={`relative w-full overflow-hidden border-y border-[#1c1c1c] py-6 bg-[#070707] ${className}`} data-testid="marquee">
      <div className="marquee-track">
        {row.map((item, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-serif text-4xl md:text-6xl italic text-[#e6e6e6] px-8">{item}</span>
            <span className="text-[#3a3a3a] text-4xl md:text-6xl">/</span>
          </span>
        ))}
      </div>
    </div>
  );
}
